module.exports = __webpack_public_path__ + "static/img/showpa.e62bb77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showpa.jpg
// module id = b1H3
// module chunks = 2